import script from "./WOrganizationSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./WOrganizationSidebar.vue?vue&type=script&lang=ts&setup=true"

import "./WOrganizationSidebar.vue?vue&type=style&index=0&id=285e8a1a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285e8a1a"]])

export default __exports__